module.exports = "<div>\n  <div class=\"submissions-empty__partials\">\n    <h3 class=\"db--h3\">This form currently has no submissions.</h3>\n  </div>\n</div>"